import React from 'react';
import { ActivationCard } from './ActivationCard';

interface ClosedScreenProps {
  onGoToLogin: () => void;
  title?: string;
  message?: string;
}

export const ClosedScreen: React.FC<ClosedScreenProps> = ({
  onGoToLogin,
  title = 'Session Closed',
  message = 'The session has been closed successfully.',
}) => (
  <ActivationCard>
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-door-closed text-secondary" style={{ fontSize: '4rem' }}></i>
      </div>
      <h1 className="h3 mb-3 fw-bold">{title}</h1>
      <p className="text-muted mb-4">{message}</p>
      <div className="alert alert-secondary" role="alert">
        <i className="fas fa-info-circle me-2"></i>
        The registration session has been closed. You can return to the login page.
      </div>
      <button onClick={onGoToLogin} className="btn btn-primary w-100">
        <i className="fas fa-sign-in-alt me-2"></i>
        Go to Login
      </button>
    </div>
  </ActivationCard>
);
